import { createStrictContext } from "@indietabletop/appkit";
import type { Product } from "../client";

export const [ProductContext, useProduct] = createStrictContext<Product>();
